import { Button } from 'antd';
import classnames from 'classnames';
import classes from './index.module.scss';

import type { ButtonProps } from 'antd';

interface ICustomButton extends ButtonProps {
  /** 偏角样式，即左下右上圆角度数偏大 */
  corner?: boolean;
}

function CustomButton(props: ICustomButton) {
  const { children, className, corner, ...rest } = props;

  return (
    <Button
      className={classnames(
        classes.wrap,
        {
          [classes.corner]: corner,
        },
        className
      )}
      {...rest}>
      {children}
    </Button>
  );
}

export default CustomButton;
